import React from 'react'
import PropTypes from 'prop-types'
import { Message, PinMessage, PinnedMessageContainer, Username, ModeratorIcon } from '../style'
import MessageWithLink from './MessageWithLink'
import PushPinIcon from '@mui/icons-material/PushPin'
import { CustomerRoles } from '../../../constants/customerRoles'

export const PinnedMessage = React.forwardRef(
  ({ isDesktop, message, getModeratorColorByUsername }, ref) => {
    const showMessage = message !== null
    return (
      <>
        {showMessage && (
          <PinMessage ref={ref} isDesktop={isDesktop}>
            <PinnedMessageContainer>
              <span>
                <ModeratorIcon isPin />
              </span>
              {isDesktop ? (
                <PushPinIcon fontSize="inherit" />
              ) : (
                <PushPinIcon fontSize="inherit" style={{ color: 'white' }} />
              )}
              <Username
                color={
                  message.role === CustomerRoles.MODERATOR
                    ? getModeratorColorByUsername(message.username)
                    : undefined
                }
                isDesktop={isDesktop}
                data-test="username-inner-chat"
              >
                {message.username}:
              </Username>
              <MessageWithLink logType="click-url-in-chat" isDesktop={isDesktop}>
                <Message isDesktop={isDesktop} data-test="user-message">
                  {message.text}
                </Message>
              </MessageWithLink>
            </PinnedMessageContainer>
          </PinMessage>
        )}
      </>
    )
  },
)

PinnedMessage.displayName = 'PinnedMessage'

PinnedMessage.propTypes = {
  isDesktop: PropTypes.bool,
  message: PropTypes.object.isRequired,
  getModeratorColorByUsername: PropTypes.func,
}
